import { useEffect, useState, ChangeEvent, useMemo } from 'react';
import { Box, FormControlLabel, Typography } from '@mui/material';
import { FilterButton, Slider, Checkbox } from '@care/react-component-lib';
import { AmplitudeEvent, trackAmplitudeEvent } from '@/lib/analyticsHelper';
import { saveFilters } from '../../../utils/filtersStorage';

interface Props {
  isClear: Boolean;
  onChange(): void;
  handleClick(): void;
}

const Hours = (props: Props) => {
  const defaultHours = useMemo(() => [5, 21], []);
  const defaultIsOvernight = false;
  const { handleClick, isClear, onChange } = props;
  const [hours, setHours] = useState(defaultHours);
  const [isOvernight, setIsOvernight] = useState(defaultIsOvernight);
  const [isSelected, setIsSelected] = useState(false);

  const onChangeTr = (val: number | number[]) => {
    /* istanbul ignore else (unreachable) */
    if (Array.isArray(val)) {
      setHours(val);
    } else {
      setHours([val, val]);
    }
  };

  const onChangeOvernight = (e: ChangeEvent<HTMLInputElement>) => {
    setIsOvernight(e.target.checked);
  };

  const formatTime = (time: number) => {
    return time < 10 ? `0${time}:00` : `${time}:00`;
  };

  const handleApply = () => {
    const hoursData = {
      hours: {
        startTime: formatTime(hours[0]),
        endTime: formatTime(hours[1]),
        isOvernight,
      },
    };

    setIsSelected(
      hours[0] !== defaultHours[0] ||
        hours[1] !== defaultHours[1] ||
        isOvernight !== defaultIsOvernight
    );

    saveFilters(hoursData, onChange);

    trackAmplitudeEvent(AmplitudeEvent.applySegmentationFilter, hoursData);
  };

  useEffect(() => {
    if (isClear) {
      setHours(defaultHours);
      setIsOvernight(defaultIsOvernight);
      setIsSelected(false);
    }
  }, [isClear, defaultHours, defaultIsOvernight]);

  return (
    <FilterButton
      label="Hours"
      field="field"
      selected={isSelected}
      onApply={handleApply}
      onClick={handleClick}>
      <Typography variant="h3" component="p" gutterBottom>
        Daytime Hours:
      </Typography>
      <Slider
        timeIncrements={60}
        min={5}
        max={21}
        value={[hours[0], hours[1]]}
        marks
        timeMode
        unit=""
        onChange={onChangeTr}
        sx={{
          '& .MuiSlider-root': {
            padding: '13px 0',
          },
        }}
      />
      <Box mt={0.5}>
        <FormControlLabel
          control={
            <Checkbox name="isOvernight" onChange={onChangeOvernight} checked={isOvernight} />
          }
          label="Overnight hours"
        />
      </Box>
    </FilterButton>
  );
};

export default Hours;
